export default "__VITE_ASSET__CtaDhPWt__"